<template>
  <div class="d-flex justify-content-around">
    <label
      v-if="label.length"
      :class="labelClass"
    >
      {{ label }}
    </label>
    <input
      @input="(event) => $emit('check-change', event.target.checked)"
      class="form-check-input"
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
    >
  </div>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    checked: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
